/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { NoteAnalysis } from "../model"
// @ts-ignore
import type { PAQuestionResult } from "../model"
// @ts-ignore
import type { Question } from "../model"
// @ts-ignore
import type { QuestionResultSaveRequest } from "../model"
/**
 * ProjectAnalyzeResourceApi - axios parameter creator
 */
export const ProjectAnalyzeResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNoteAnalysis: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getNoteAnalysis", "noteId", noteId)
      const localVarPath = `/analyzes/analysis/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestions: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getQuestions", "noteId", noteId)
      const localVarPath = `/analyzes/questions/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResponses: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getResponses", "noteId", noteId)
      const localVarPath = `/analyzes/projects/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} noteId
     * @param {QuestionResultSaveRequest} questionResultSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveResponse: async (
      noteId: string,
      questionResultSaveRequest: QuestionResultSaveRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("saveResponse", "noteId", noteId)
      // verify required parameter 'questionResultSaveRequest' is not null or undefined
      assertParamExists("saveResponse", "questionResultSaveRequest", questionResultSaveRequest)
      const localVarPath = `/analyzes/projects/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        questionResultSaveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProjectAnalyzeResourceApi - functional programming interface
 */
export const ProjectAnalyzeResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectAnalyzeResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNoteAnalysis(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteAnalysis>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNoteAnalysis(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectAnalyzeResourceApi.getNoteAnalysis"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getQuestions(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Question>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestions(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectAnalyzeResourceApi.getQuestions"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResponses(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PAQuestionResult>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getResponses(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectAnalyzeResourceApi.getResponses"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} noteId
     * @param {QuestionResultSaveRequest} questionResultSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveResponse(
      noteId: string,
      questionResultSaveRequest: QuestionResultSaveRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PAQuestionResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveResponse(
        noteId,
        questionResultSaveRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectAnalyzeResourceApi.saveResponse"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProjectAnalyzeResourceApi - factory interface
 */
export const ProjectAnalyzeResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectAnalyzeResourceApiFp(configuration)
  return {
    /**
     *
     * @param {ProjectAnalyzeResourceApiGetNoteAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNoteAnalysis(
      requestParameters: ProjectAnalyzeResourceApiGetNoteAnalysisRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<NoteAnalysis> {
      return localVarFp
        .getNoteAnalysis(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {ProjectAnalyzeResourceApiGetQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestions(
      requestParameters: ProjectAnalyzeResourceApiGetQuestionsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Question>> {
      return localVarFp
        .getQuestions(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {ProjectAnalyzeResourceApiGetResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResponses(
      requestParameters: ProjectAnalyzeResourceApiGetResponsesRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<PAQuestionResult>> {
      return localVarFp
        .getResponses(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {ProjectAnalyzeResourceApiSaveResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveResponse(
      requestParameters: ProjectAnalyzeResourceApiSaveResponseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PAQuestionResult> {
      return localVarFp
        .saveResponse(
          requestParameters.noteId,
          requestParameters.questionResultSaveRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getNoteAnalysis operation in ProjectAnalyzeResourceApi.
 */
export interface ProjectAnalyzeResourceApiGetNoteAnalysisRequest {
  readonly noteId: string
}

/**
 * Request parameters for getQuestions operation in ProjectAnalyzeResourceApi.
 */
export interface ProjectAnalyzeResourceApiGetQuestionsRequest {
  readonly noteId: string
}

/**
 * Request parameters for getResponses operation in ProjectAnalyzeResourceApi.
 */
export interface ProjectAnalyzeResourceApiGetResponsesRequest {
  readonly noteId: string
}

/**
 * Request parameters for saveResponse operation in ProjectAnalyzeResourceApi.
 */
export interface ProjectAnalyzeResourceApiSaveResponseRequest {
  readonly noteId: string

  readonly questionResultSaveRequest: QuestionResultSaveRequest
}

/**
 * ProjectAnalyzeResourceApi - object-oriented interface
 */
export class ProjectAnalyzeResourceApi extends BaseAPI {
  /**
   *
   * @param {ProjectAnalyzeResourceApiGetNoteAnalysisRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getNoteAnalysis(
    requestParameters: ProjectAnalyzeResourceApiGetNoteAnalysisRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectAnalyzeResourceApiFp(this.configuration)
      .getNoteAnalysis(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {ProjectAnalyzeResourceApiGetQuestionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getQuestions(
    requestParameters: ProjectAnalyzeResourceApiGetQuestionsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectAnalyzeResourceApiFp(this.configuration)
      .getQuestions(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {ProjectAnalyzeResourceApiGetResponsesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getResponses(
    requestParameters: ProjectAnalyzeResourceApiGetResponsesRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectAnalyzeResourceApiFp(this.configuration)
      .getResponses(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {ProjectAnalyzeResourceApiSaveResponseRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saveResponse(
    requestParameters: ProjectAnalyzeResourceApiSaveResponseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectAnalyzeResourceApiFp(this.configuration)
      .saveResponse(requestParameters.noteId, requestParameters.questionResultSaveRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
